/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, TemplateRef, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {NgbTooltip, NgbTooltipConfig, Placement} from '@ng-bootstrap/ng-bootstrap';
import {Subscription, timer} from 'rxjs';
import {debounceTime, filter} from 'rxjs/operators';

@Component({
    selector: 'app-tooltip-persistent',
    templateUrl: './tooltip-persistent.component.html',
    styleUrls: ['../../styles/base.component.css', './tooltip-persistent.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TooltipPersistentComponent implements AfterViewInit, OnDestroy {
    @Input() tooltipBody: string | TemplateRef<any>;
    @Input() closeTooltipEvent = new EventEmitter<void>();
    @Input() placement: Placement = 'auto';
    @Input() disable = false;
    @Input() extraCssClasses: string[] = [];
    @Input() tooltipToggle = new EventEmitter<boolean>();
    @ViewChild('tooltip') tooltip: NgbTooltip;
    public readonly CSS_BASE_CLASS = 'orcan-persistent-tooltip';
    public autoClose: boolean | 'inside' | 'outside' = false;
    public triggers = 'manual';
    private keepOpen = true;
    private subscriptions = new Subscription();

    constructor(private config: NgbTooltipConfig) {
    }

    get tooltipClass(): string {
        if (this.extraCssClasses == null) {
            return this.CSS_BASE_CLASS;
        }

        return [this.CSS_BASE_CLASS, ...this.extraCssClasses].join(' ');
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    ngAfterViewInit(): void {
        // Queueing the tooltip to open only *after* the AfterViewInit hook finishes.
        // That way, it won't trigger another render while this one is still occurring.
        timer(0).subscribe(() => {
            this.tooltip.open();
        });

        this.subscriptions.add(
                this.closeTooltipEvent.subscribe(() => {
                    this.tooltip.close();
                    this.keepOpen = false;
                })
        );

        this.subscriptions.add(this.tooltipToggle
                .pipe(debounceTime(this.config.openDelay),
                        filter(show => show))
                .subscribe(() => this.tooltip.open())
        );
    }
}
